import { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { ServiceItem } from 'orderme-api-integration-client';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/store';
import { roundDoubleNumbers } from '../../helpers/currency';
import { LoginDialog } from '../auth/login/loginDialog';
import { useRouteNavigator } from '../../routes/useRouteNavigator';
import { CreditsPaymentParam } from '../payment/creditsPayments';

interface BuyCreditsActionBoxProps {
  service: ServiceItem;
  visible: boolean;
  isSticky?: boolean;
}

export function BuyCreditsActionBox(props: BuyCreditsActionBoxProps) {
  const { service, visible, isSticky = false } = props;
  const { t } = useTranslation();
  const routeNavigator = useRouteNavigator();
  const isUserLoggedIn: boolean = useAppSelector((state: RootState) => state.authState.isLoggedIn);
  const [openLogin, setOpenLogin] = useState(false);

  const buyCredits = () => {
    if (!isUserLoggedIn) {
      setOpenLogin(true);
      return;
    }
    routeNavigator.goToCreditsPayments({
      state: {
        id: service.id,
        price: service.price,
        credits: service.originalPrice,
      } as CreditsPaymentParam,
    });
  };

  return (
    <Box
      sx={{
        display: !visible && 'none',
        position: isSticky ? 'sticky' : 'static',
        bottom: 0,
        zIndex: 1,
        backgroundColor: 'white',
      }}
    >
      <Box sx={{ mt: '20px', textAlign: 'center' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Typography
            sx={{
              fontSize: '28px',
              opacity: 0.7,
              textDecoration: 'line-through',
              pr: '15px',
              display: service.originalPrice - service.price === 0 ? 'none' : 'inline-block',
            }}
          >
            {roundDoubleNumbers(service.originalPrice)} €
          </Typography>
          <Typography sx={{ fontSize: '28px', fontWeight: 'bold' }}> {roundDoubleNumbers(service.price)} €</Typography>
        </Box>
        <Button
          sx={{ minWidth: '150px' }}
          onClick={() => {
            buyCredits();
          }}
          variant="contained"
        >
          {t('payment:purchase')}
        </Button>
      </Box>
      <LoginDialog open={openLogin} onClose={() => setOpenLogin(false)} />
    </Box>
  );
}
